exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".l9MzjwvzuaJmI2KjgpSYX{display:inline-block;background-color:#757575;border-radius:50%;cursor:pointer;width:8px;height:8px;margin:5px}.l9MzjwvzuaJmI2KjgpSYX.zkQTmx2DPdX6obiQaBxBm{background-color:#bdbdbd}\n", ""]);

// Exports
exports.locals = {
	"pip": "l9MzjwvzuaJmI2KjgpSYX",
	"active": "zkQTmx2DPdX6obiQaBxBm"
};